namespace GeniuzPOS.Member {
    export namespace PermissionKeys {
        export const General = "";

        namespace PsMember {
            export const Delete = "3Member:\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:Delete";
            export const Modify = "3Member:\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:Modify";
            export const View = "3Member:\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:View";
        }

        namespace MbReport02 {
            export const Modify = "3Member:\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:Modify";
            export const View = "3Member:\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:View";
        }

        namespace Mbreport01 {
            export const View = "3Member:\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01:View";
        }
    }
}
